import { useEffect, useState } from 'react';

export function useNycTime() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(interval);
  }, []);

  const nycHour = Number(
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: 'numeric',
      hour12: false,
    }).format(now),
  );

  const period =
    nycHour < 5 ? 'Hello' : nycHour < 12 ? 'Good morning' : nycHour < 17 ? 'Good afternoon' : 'Good evening';

  const nycTime = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).format(now);

  const nycDateParts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).formatToParts(now);

  const weekday = nycDateParts.find((p) => p.type === 'weekday')?.value.toUpperCase() ?? '';
  const month = nycDateParts.find((p) => p.type === 'month')?.value.toUpperCase() ?? '';
  const day = nycDateParts.find((p) => p.type === 'day')?.value ?? '';
  const year = nycDateParts.find((p) => p.type === 'year')?.value ?? '';
  const nycDate = `${weekday} ${month} ${day}, ${year}`;

  return { period, nycTime, nycDate };
}
